"use strict";
var ArrayObservable_1 = require('./ArrayObservable');
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/rxjs/observable/of.js
// module id = ../../../../rxjs/observable/of.js
// module chunks = 4